import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { FeatureSpecsEntities, FeatureSpecsPaths, VehicleModel } from 'client/data/models/vehicle-v2';
import { getModelIncentivesLink } from 'site-modules/shared/utils/incentives-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

import './ev-tax-credit-message.scss';

export function EvTaxCreditMessageUI({
  className = null,
  styleAttributes = null,
  text = null,
  vehicleParams: { makeName, modelName, year, makeSlug, modelSlug },
  isUsed = false,
}) {
  if (!styleAttributes || !(styleAttributes.pluginElectric || styleAttributes.electric)) {
    return null;
  }

  return (
    <div className={classnames('ev-tax-credit-message medium rounded-8 py-1', className)}>
      {text}&nbsp;
      <Link
        to={
          isUsed ? '/electric-car/tax-credits-rebates-incentives/' : getModelIncentivesLink(makeSlug, modelSlug, year)
        }
        className="text-primary-darker text-underline"
      >
        See {year} {makeName} {modelName} Incentives
      </Link>
    </div>
  );
}

EvTaxCreditMessageUI.propTypes = {
  vehicleParams: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    year: PropTypes.string,
    makeSlug: PropTypes.string,
    modelSlug: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  styleAttributes: FeatureSpecsEntities.StyleAttributes,
  text: PropTypes.string,
  isUsed: PropTypes.bool,
};

export const propsAreEqual = (prevProps, { styleAttributes }) => !styleAttributes;
export const EvTaxCreditMessage = connectToModel(React.memo(EvTaxCreditMessageUI, propsAreEqual), {
  styleAttributes: bindToPath(({ styleId }) => FeatureSpecsPaths.buildStyleAttributesPath(styleId), VehicleModel),
});
